import { isWeb } from "@memorang/helpers/platform";
import { Appbar, Text } from "react-native-paper";
import { useDevice } from "../../useDevice";
import Box from "../Box";

type Props = {
	title?: string;
	subtitle?: string;
	onBack?: () => void;
};

const OnboardingAppBar = ({ title, subtitle, onBack }: Props) => {
	const { isMobile } = useDevice();
	const mode = subtitle ? "medium" : "center-aligned";

	return (
		<Appbar.Header
			mode={mode}
			elevated={false}
			// @ts-ignore web only style
			style={{
				...(isWeb ? { height: "fit-content" } : {}),
			}}
		>
			{onBack && (
				<Appbar.BackAction onPress={onBack} style={{ marginLeft: 0 }} />
			)}
			<Appbar.Content
				style={{
					alignItems: isMobile ? undefined : "center",
				}}
				title={
					<Box
						alignItems={isMobile ? undefined : "center"}
						//TODO: Having subtitle on mobile is having overlapping issue with the back button
						marginTop={subtitle && !isWeb && onBack ? 20 : 0}
						gap={8}
					>
						{title && <Text variant="titleLarge">{title}</Text>}
						{subtitle && <Text variant="labelLarge">{subtitle}</Text>}
					</Box>
				}
			/>
		</Appbar.Header>
	);
};

export default OnboardingAppBar;
